import React from "react";
import { ClientContext } from "@thd-nucleus/app-render/dist/client";
import B2BTheme from "@thd-olt-global/b2b-theme";
import { NewRelicBridge } from "@thd-olt-component-react/new-relic-bridge";
import { whyDidYouRender } from "../wdyr.js";
import { App } from "./App";
import { getRoutes } from "./routes.js";

NewRelicBridge.init();
whyDidYouRender.init();

document.addEventListener("DOMContentLoaded", async () => {
  const client = new ClientContext({
    opts: {
      federation: true,
    },
  });
  client.setExperienceRoutes(getRoutes());
  if (client.customer.type === "b2b") {
    client.setTheme({ name: "b2b", template: B2BTheme });
  }
  client.render(
    <App
      prefetchPip={client.featureSwitches.prefetchPip}
      productPodHoverDelay={client.featureSwitches.productPodHoverDelay}
    />
  );
});
